import {
  validateRequired,
  validateDecimalWithLength,
  validateIntLength,
} from "../../../../helpers/validationsForm";

const Inputs = (id) => {
  return [
    {
      id: "1",
      label: "Nombre de la Zona",
      name: "nombre",
      type: "text",
      placeholder: "Ej: Centro, Urbana, Rural...", 
    },
    {
      id: "2",
      label: "Descripción",
      name: "descripcion",
      type: "text",
      placeholder: "Descripción de la zona",
    },
    {
      id: "3",
      label: "Radio (km)",
      name: "radio_km",
      type: "number",
      placeholder: "Ej: 50", 
    },
    {
      id: "4",
      label: "Latitud",
      name: "latitud",
      type: "number",
      placeholder: "Ej: -27.7834",
      step: "0.0000001", 
    },
    {
      id: "5",
      label: "Longitud",
      name: "longitud",
      type: "number",
      placeholder: "Ej: -64.2642",
      step: "0.0000001", 
    },
    {
      id: "6",
      label: "Monto Mínimo ($)",
      name: "monto_minimo",
      type: "number",
      placeholder: "Ej: 5000", 
    },
    {
      id: "7",
      label: "Costo de Envío ($)",
      name: "costo_envio",
      type: "number",
      placeholder: "Ej: 1000", 
    },
    {
      id: "8",
      label: "Envío Gratis Desde ($)",
      name: "envio_gratis_desde",
      type: "number",
      placeholder: "Ej: 25000 (dejar vacío = nunca)",
      // Sin validación - campo opcional
    },
    {
      id: "9",
      label: "Límite Pedidos/Día",
      name: "limite_pedidos_dia",
      type: "number",
      placeholder: "Ej: 50 (vacío = sin límite)",
      // Sin validación - campo opcional
    },
    {
      id: "10",
      label: "Horario Desde",
      name: "horario_desde",
      type: "time",
      placeholder: "08:00",
    },
    {
      id: "11",
      label: "Horario Hasta",
      name: "horario_hasta",
      type: "time",
      placeholder: "18:00",
    },
    {
      id: "12",
      label: "Días de Entrega",
      name: "dias_entrega",
      type: "text",
      placeholder: "1,2,3,4,5 (Lun-Vie)",
    },
    {
      id: "13",
      label: "Tiempo de Entrega",
      name: "tiempo_entrega",
      type: "text",
      placeholder: "Ej: 24-48hs",
    },
    {
      id: "14",
      label: "Acepta Entregas",
      name: "acepta_entregas",
      type: "select",
      options: [
        { value: 1, label: "Sí" },
        { value: 0, label: "No (Pausada)" },
      ],
    },
    {
      id: "15",
      label: "Activa",
      name: "activa",
      type: "select",
      options: [
        { value: 1, label: "Visible" },
        { value: 0, label: "Oculta" },
      ],
    },
  ];
};

export default Inputs;